// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Automations_Content_Content_SetupAction_Content_Content(
  $location_id: uuid!
  $app_id: uuid!
  $events: [jsonb!]!
) {
  events_events_integration_automation_create(
    location_id: $location_id
    events: $events
    app_id: $app_id
  ) {
    ids
  }
}

`